/**
 * Administração do Sistema — hub + uma rota por módulo (at-73).
 *
 * `/admin/sistema` continua existindo e é a porta de entrada (não quebra link nem
 * hábito); o que mudou é que ela abre a seleção de módulo em vez de cair direto nas
 * abas da Oficina.
 */
export const ADMIN_SISTEMA = () => `/admin/sistema`;
export const ADMIN_SISTEMA_OFICINA = () => `/admin/sistema/oficina`;
export const ADMIN_SISTEMA_COTACOES = () => `/admin/sistema/cotacoes`;
// 12/08/2026: a configuração do Orçamento Cilia era `/orcamentos-cilia/configuracoes`,
// alcançável por um botão na tela de orçamentos. Virou módulo daqui, como a de Cotações.
export const ADMIN_SISTEMA_CILIA = () => `/admin/sistema/cilia`;
/**
 * Integrações com plataformas externas (at-07).
 *
 * ⚠️ Não é "configuração da Oficina": integração é transversal — o mesmo OctaDesk vai
 * atender convite de cotação, link de checklist e pesquisa de satisfação (entrega 2). Por
 * isso é módulo próprio no hub, e não uma sexta aba da Oficina.
 */
export const ADMIN_SISTEMA_INTEGRACOES = () => `/admin/sistema/integracoes`;
/**
 * Consumo da API de IA (at-12): tokens e custo estimado das três superfícies que chamam a
 * Anthropic (assistente do Dashboard Oficina, redação e descoberta do Radar). Módulo próprio
 * porque IA é transversal — não pertence à configuração de nenhum módulo de negócio.
 */
export const ADMIN_SISTEMA_CONSUMO_IA = () => `/admin/sistema/consumo-ia`;
/**
 * Logs do sistema (transversal/at-91, ADR 0062): tudo o que aconteceu na aplicação — quem, quando,
 * o quê, onde e se deu certo. ADMIN e TI.
 */
export const ADMIN_SISTEMA_LOGS = () => `/admin/sistema/logs`;
/**
 * Comissionamentos (comissionamentos/at-01): sincronização dos boletos do SGA por data de
 * vencimento — a base que o cálculo de repasse consome.
 *
 * ⚠️ É o primeiro módulo do hub alcançado por um papel OPERACIONAL sem TI: o COMISSIONAMENTO
 * entra (ele opera a sincronização) e o TI **não**, porque o ADR 0012 mantém Comissionamentos
 * fora do alcance dele, telas e rotas. O card de Cotações tem TI por ser outro caso — Portal
 * não é módulo financeiro.
 */
export const ADMIN_SISTEMA_COMISSIONAMENTOS = () => `/admin/sistema/comissionamentos`;

/**
 * Grupos de Acesso (at-81, ADR 0044): conjuntos NOMEADOS de perfis, com tela inicial própria.
 * Módulo daqui porque acesso é transversal — não pertence à configuração de módulo nenhum.
 */
export const ADMIN_SISTEMA_GRUPOS = () => `/admin/sistema/grupos-de-acesso`;

/**
 * Radar (transversal/at-82, ADR 0046): como os achados do assistente estão sendo avaliados pela
 * equipe, em cada radar, e o histórico das explorações.
 *
 * ⚠️ **ADMIN somente — nem TI, nem CONTAC.** Não é o critério dos outros cartões sem TI (módulo
 * financeiro): aqui a tela é transversal, mas o CONTEÚDO dela carrega os títulos e os números dos
 * achados, e o Radar Financeiro é feito de valores do Contac — que o ADR 0012 mantém fora do
 * alcance do TI. Se um dia existir radar só da Oficina, a matriz por radar resolve isso sem abrir
 * a tela inteira.
 */
export const ADMIN_SISTEMA_RADAR = () => `/admin/sistema/radar`;
// at-100: de-paras do Dashboard de Compras (nome do comprador, oficina, setor do local).
export const ADMIN_SISTEMA_COMPRAS = () => `/admin/sistema/compras`;

/**
 * Contac (contac/at-13, ADR 0007 do Contac): a régua de cores do Dashboard de Placas e as regras
 * do Radar do Relacionamento.
 *
 * ⚠️ ADMIN e CONTAC, **sem TI**: o Contac é módulo financeiro e o ADR 0012 o mantém fora do
 * alcance dele. É o segundo cartão do hub sem TI (o primeiro foi Comissionamentos), e o segundo
 * alcançado por papel operacional — o CONTAC é o dono do módulo.
 */
export const ADMIN_SISTEMA_CONTAC = () => `/admin/sistema/contac`;

/**
 * Oficina Externa (at-114, ADR 0059): regiões, oficinas, etapas, o template do checklist da
 * visita e o limiar de dias sem visita.
 *
 * ADMIN e TI, como os demais cartões de configuração de estrutura — é o mesmo tipo de cadastro
 * que o TI já mantém na Oficina (esteiras, tags, templates de checklist). As quatro ações do
 * INSPETOR (cadastrar veículo, registrar visita, foto, saída) vivem fora daqui, e ele não as tem.
 */
export const ADMIN_SISTEMA_OFICINA_EXTERNA = () => `/admin/sistema/oficina-externa`;
